import { ExchangeRateApiProvider } from "./exchangerate";
import { FixerProvider } from "./fixer";
import { type FxProvider } from "./types";

export const ALL_PROVIDERS: FxProvider[] = [
  // Prefer Fixer (historical support) first by default
  FixerProvider,
  ExchangeRateApiProvider,
];

export function getProvidersOrdered(preferred?: string): FxProvider[] {
  const envPref = (
    preferred ||
    ((import.meta.env.VITE_FX_FALLBACK_SOURCE as string | undefined) ?? "")
  ).toLowerCase();

  if (!envPref) return ALL_PROVIDERS;

  const found = ALL_PROVIDERS.find((p) => p.name === envPref);
  if (!found) return ALL_PROVIDERS;

  return [found, ...ALL_PROVIDERS.filter((p) => p.name !== envPref)];
}

export function getProviderByName(name: string): FxProvider | undefined {
  const needle = name.toLowerCase();
  return ALL_PROVIDERS.find((p) => p.name === needle);
}

export function parseSupportedCurrencies(): string[] {
  const raw = import.meta.env.VITE_SUPPORTED_CURRENCIES as string | undefined;
  if (!raw) return [];
  return raw
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean)
    .map((s) => s.toUpperCase());
}
